let deferredInstallPrompt = null;
const installStateListeners = new Set();

const isBrowser = typeof window !== "undefined";

const notifyInstallState = () => {
  installStateListeners.forEach((listener) => listener(getPwaInstallState()));
};

if (isBrowser) {
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredInstallPrompt = event;
    notifyInstallState();
  });

  window.addEventListener("appinstalled", () => {
    deferredInstallPrompt = null;
    notifyInstallState();
  });
}

export const isPwaInstalled = () => {
  if (!isBrowser) return false;

  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
};

export const isIosDevice = () => {
  if (!isBrowser) return false;

  const userAgent = window.navigator.userAgent || "";
  const isClassicIos = /iPad|iPhone|iPod/.test(userAgent);
  const isIpadDesktopMode =
    /Macintosh/.test(userAgent) && window.navigator.maxTouchPoints > 1;

  return isClassicIos || isIpadDesktopMode;
};

export const getPwaInstallState = () => ({
  installed: isPwaInstalled(),
  promptAvailable: Boolean(deferredInstallPrompt),
  iosManualInstall: isIosDevice() && !isPwaInstalled(),
});

export const subscribeToPwaInstallState = (listener) => {
  installStateListeners.add(listener);
  listener(getPwaInstallState());

  return () => installStateListeners.delete(listener);
};

export const promptPwaInstallation = async () => {
  if (!deferredInstallPrompt) {
    return { outcome: "unavailable" };
  }

  const prompt = deferredInstallPrompt;
  await prompt.prompt();
  const choice = await prompt.userChoice;
  deferredInstallPrompt = null;
  notifyInstallState();

  return choice;
};
